import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/admin/consented-emails/page.tsx");
